import { useReducer, useEffect, useRef } from 'react'
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Modal, Button } from 'semantic-ui-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { UniversalLink } from '@plone/volto/components';
import { searchContent } from '@plone/volto/actions';
import { Icon } from '../'
import { isEmpty } from 'lodash';
import imgPalafollsW from './img/palafolls-blanc.svg';
import { FocusTrap } from 'focus-trap-react';


const HIDE_ONBOARDING_KEY = 'hideOnboarding';

const initialState = {
  open: false,
};

function reducerOnboarding(state, action) {
  switch (action.type) {
    case 'open':
      return { ...state, open: true };
    case 'close':
      return { ...state, open: false };
    default:
      return state;
  }
}

const Onboarding = (props) => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.userSession.token, shallowEqual);
  const [state, onboardingDispatch] = useReducer(reducerOnboarding, initialState);
  const onboardingLinks = useSelector((state) => state.search.subrequests.onboardingLinks?.items);
  const location = useLocation();

  const modalRef = useRef(null);
  const previouslyFocusedElement = useRef(null);

  if (location.pathname !== '/') {
    return null;
  }

  if (token) {
    return null;
  }

  useEffect(() => {
    dispatch(
      searchContent(
        '/portada/onboarding',
        {
          portal_type: ['Link'],
          sort_on: 'getObjPositionInParent',
          metadata_fields: ['getRemoteUrl', 'remoteUrl', 'content_icon']
        },
        'onboardingLinks',
      ),
    );
  }, [dispatch]);

  useEffect(() => {
    const hide = localStorage.getItem(HIDE_ONBOARDING_KEY) === 'true';
    if (!hide) {
      onboardingDispatch({ type: 'open' });
    }
  }, []);

  useEffect(() => {
    if (state.open) {
      previouslyFocusedElement.current = document.activeElement;
      setTimeout(() => {
        if (modalRef.current) {
          modalRef.current.focus();
        }
      }, 0);
    }
  }, [state.open]);

  const handleClose = () => {
    localStorage.setItem(HIDE_ONBOARDING_KEY, 'true');
    onboardingDispatch({ type: 'close' });
    if (previouslyFocusedElement.current) {
      previouslyFocusedElement.current.focus();
    }
  };

  if (!state.open) {
    return null;
  }

  return (
    <Modal
      className="onBoarding"
      size="tiny"
      open={state.open}
      onClose={handleClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby=""
    >
      <FocusTrap active={state.open}>
        <div ref={modalRef} tabIndex="-1">
          <Button className="onBoarding__btnClose close" onClick={handleClose}>
            <span className="visually-hidden">
              <FormattedMessage id="Close" defaultMessage="Close" />
            </span>
            <FontAwesomeIcon icon={faXmark} />
          </Button>

          <Modal.Header className="onBoarding__header">
            <div className="onBoarding__logo">
              <img src={imgPalafollsW} width="64" height="76" alt="" />
            </div>
            <h2 id="onBoardingTitle" className="onBoarding__title">
              <FormattedMessage
                id="Benvinguts"
                defaultMessage="Benvinguts al lloc web de {br}l'Ajuntament de Palafolls"
                values={{ br: <br /> }}
              />
            </h2>
            <p className="onBoarding__description">
              <FormattedMessage
                id="EtPodemAjudar"
                defaultMessage="Et podem ajudar? {br}Potser una de les següents opcions s'ajusta a les teves necessitats"
                values={{ br: <br /> }}
              />
            </p>
          </Modal.Header>

          <Modal.Content className="onBoarding__content">
            {!isEmpty(onboardingLinks) &&
              <ul className="onBoarding__actionsList list-unstyled">
                {onboardingLinks.map((item) => (
                  <li className="onBoarding__actionsList__item" key={item['@id']}>
                    <UniversalLink className="ui button onBoarding__action primary" href={item.remoteUrl}>
                      {item?.content_icon && (<Icon name={item.content_icon} className="directLinksItem__icon" />)}
                      {item.title}
                    </UniversalLink>
                  </li>
                ))}
                <li className="onBoarding__actionsList__item onBoarding__actionsList__item--ignore">
                  <Button className="onBoarding__action" onClick={handleClose} basic>
                    <FormattedMessage id="NoGracies" defaultMessage="No gràcies" />
                  </Button>
                </li>
              </ul>
            }
          </Modal.Content>
        </div>
      </FocusTrap>
    </Modal>
  );
};

export default Onboarding;